// extracted by mini-css-extract-plugin
module.exports = {"pageTitleBox":"PageTitle_pageTitleBox__QPMnz","pageTitle":"PageTitle_pageTitle__1JLWa"};